import { Stack, Visibility } from "@octopus-energy/coral/atoms"
import { useIsClient } from "@octopus-energy/utils"
import { Actions } from "@/components/organisms"
import { useCallToActionLabel } from "@/hooks/useCallToActionLabel"
import { useDashboardLayoutBreadcrumbContext } from "../contexts/DashboardLayoutBreadcrumbContext"

export function DashboardLayoutBackButton() {
    const t = useCallToActionLabel()
    const { previousPage } = useDashboardLayoutBreadcrumbContext()
    const isClient = useIsClient()

    if (!isClient || !previousPage) return null

    return (
        <Visibility hidden={{ base: true, md: false }}>
            <Actions>
                <Stack
                    fullWidth
                    justifyContent="center"
                >
                    <Actions.Cancel href={previousPage.href}>{t("back")}</Actions.Cancel>
                </Stack>
            </Actions>
        </Visibility>
    )
}

DashboardLayoutBackButton.messages = [...useCallToActionLabel.messages] as const
